import { DateUnit } from "../graphQLTypes";

export const getDateUnitText = (unit: DateUnit, value: number): string => {
  if (value === 1) {
    return unit.toLocaleLowerCase();
  }
  return `${unit.toLocaleLowerCase()}s`;
};
